export const handleClickAnchor = (e) => {
  const t = e.currentTarget
  const id = t.getAttribute("href")
  const elem = document.querySelector(`#${id.split("#")[1]}`)

  if (!elem) {
    return
  }

  const headerOffset = 64
  const elementPosition = elem.getBoundingClientRect().top
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  })

  e.preventDefault()
}
